import React from "react";

function Schedules() {

    return (
        <div className="w-full max-w-[1280px] mx-auto px-4 2xl:px-0 flex flex-col md:flex-row justify-evenly gap-8 py-10 md:py-20">
            {/* Address */}
            <div className="text-center">
                <h2 className="text-lg font-semibold mb-2">Address</h2>
                <div className="border-b-4 border-green-600 w-16 mx-auto mb-4" />
                <h3 className="text-base mb-2">Ruiru (Doctors Plaza) Ground Floor</h3>
                <h3 className="text-base">Room number F06.</h3>
            </div>

            {/* Working Hours */}
            <div className="text-center">
                <h2 className="text-lg font-semibold mb-2">Working Hours</h2>
                <div className="border-b-4 border-green-600 w-16 mx-auto mb-4" />
                <h3 className="text-base mb-2">Monday - Saturday: 0800 - 1800</h3>
                <h3 className="text-base">Sunday: Closed</h3>
            </div>

            {/* Contact Info */}
            <div className="text-center">
                <h2 className="text-lg font-semibold mb-2">Contact Info</h2>
                <div className="border-b-4 border-green-600 w-16 mx-auto mb-4" />
                <h3 className="text-base mb-2">Phone: +254729569381</h3>
                <h3 className="text-base">Email: ihpsy18@gmail.com</h3>
            </div>
        </div>
    );
}

export default Schedules;
